function showKonfi(hoehe,breite,masA,masB,masC,masD,form,position) {
  var imgSrc = " https://configurator.cubecamp.de/configuration?hoehe="+hoehe+"&breite="+breite+"&position="+position+"&masA="+masA+"&masB="+masB+"&masC="+masC+"&masD="+masD+"&form="+form+"";
  // var imgSrc = "https://ryukoch.com/cms/testhdekonfi/eingang14.php?hoehe="+hoehe+"&breite="+breite+"&position="+position+"&masA="+masA+"&masB="+masB+"&masC="+masC+"&masD="+masD+"&form="+form+"";
  document.getElementById("cubeKonfiIMG").src=imgSrc;
};

showKonfi();

$(".btnKonfi").on( "click", function() {
  document.getElementById("cubeKonfiIMG").src="";
  var hoehe = $('input[name="cubeKonfiHoehe"]').val();
  var breite = $('input[name="cubeKonfiBreite"]').val();
  var masA = $('input[name="cubeKonfiMasA"]').val();
  var masB = $('input[name="cubeKonfiMasB"]').val();
  var masC = $('input[name="cubeKonfiMasC"]').val();
  var masD = $('input[name="cubeKonfiMasD"]').val();
  var position = $('input[name="cubeKonfiPos"]').val();
  var form = $('select[name="cubeKonfiForm"] :selected').val();
  showKonfi(hoehe,breite,masA,masB,masC,masD,form,position);
});